
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.featured-grid{
  display:grid;
  row-gap:2rem;
  column-gap:3.5rem;
}

@media (min-width: 1280px){

  .featured-grid{
    row-gap:1.5rem;
  }

  .featured-grid{
    column-gap:2rem;
  }
}

.featured-grid ::slotted(*:first-child){
  height:30rem !important;
}

@media (min-width: 768px){

  .featured-grid ::slotted(*:first-child){
    height:24rem !important;
  }
}

@media (min-width: 1024px){

  .featured-grid ::slotted(*:first-child){
    height:30rem !important;
  }
}

@media (min-width: 1280px){

  .featured-grid ::slotted(*:first-child){
    height:auto !important;
  }
}

.featured-grid ::slotted(*:nth-child(2)), .featured-grid ::slotted(*:nth-child(3)){
  height:32.5rem;
}

@media (min-width: 768px){

  .featured-grid ::slotted(*:nth-child(2)), .featured-grid ::slotted(*:nth-child(3)){
    height:auto;
  }
}

@media (min-width: 1280px){
  .featured-grid{
    grid-template-columns:1fr 1fr;
    grid-template-rows:18rem 18rem;
  }

  .featured-grid ::slotted(*:first-child){
    grid-area:1 / 1 / 3 / 2;
  }
}
`;